import React from 'react';
import { SvgIconProps } from '../types';

export default function Family({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clip-path="url(#clip0_20708_74855)">
        <path
          d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z"
          fill={fill}
        />
        <path
          d="M31.601 34.8433C33.1882 34.8433 34.475 33.5565 34.475 31.9692C34.475 30.382 33.1882 29.0952 31.601 29.0952C30.0137 29.0952 28.7269 30.382 28.7269 31.9692C28.7269 33.5565 30.0137 34.8433 31.601 34.8433Z"
          fill="white"
        />
        <path
          d="M37.1631 34.8167C37.1266 34.7702 38.3015 32.8022 38.4077 32.5699C38.7694 31.7801 39.0747 30.9504 39.2407 30.0941C39.2971 29.8087 39.3369 29.5167 39.2838 29.2313C39.2307 28.9459 39.0648 28.6704 38.8026 28.5476C38.3546 28.3385 37.8169 28.6538 37.5415 29.0653C36.9806 29.9116 36.672 30.9338 36.1675 31.8199C35.6631 32.706 35.0956 33.4527 34.4252 34.1596C33.0811 35.5734 31.4018 36.6686 29.5566 37.3057C28.8929 37.5347 28.2026 37.6609 27.5156 37.7969C27.0476 37.8865 26.5133 38.0126 26.2943 38.4374C26.0454 38.9153 26.3939 39.5459 26.8983 39.7284C27.874 40.0835 29.4006 39.5924 30.3531 39.3169C31.5412 38.9718 32.6795 38.4607 33.7216 37.7969C33.6154 37.933 32.6563 39.2306 32.6231 39.1908L35.3445 42.5825C36.2073 42.1212 37.1399 41.7894 37.953 41.2451C38.7661 40.7008 39.473 39.8844 39.5626 38.912C39.6356 38.0989 39.2705 37.3024 38.7794 36.6486C38.2882 35.9948 37.6809 35.4406 37.1631 34.8101V34.8167Z"
          fill="white"
        />
        <path
          d="M18.3492 34.8433C19.9365 34.8433 21.2233 33.5565 21.2233 31.9692C21.2233 30.382 19.9365 29.0952 18.3492 29.0952C16.762 29.0952 15.4752 30.382 15.4752 31.9692C15.4752 33.5565 16.762 34.8433 18.3492 34.8433Z"
          fill="white"
        />
        <path
          d="M12.7971 34.8202C12.7805 34.8368 11.6853 32.8987 11.6089 32.7328C11.2837 32.0325 9.81351 28.9793 11.1576 28.5744C12.4818 28.1761 12.8601 30.0977 13.3214 30.9606C14.1046 32.4241 15.0936 33.7881 16.3215 34.9132C17.5163 36.0084 18.9467 36.8712 20.5031 37.3325C21.2366 37.5516 21.9899 37.671 22.7234 37.8735C23.1747 37.9996 23.7655 38.1888 23.7455 38.7596C23.719 39.4466 23.1614 39.9178 22.2787 39.8216C21.1536 39.7021 20.0452 39.4432 18.9765 39.0749C18.4522 38.8956 17.9378 38.6899 17.4333 38.4609C17.118 38.3182 16.4211 38.0693 16.2684 37.7275C16.2684 37.7275 16.6501 38.5837 17.3304 39.1943L14.6124 42.5828C14.6124 42.5828 9.40863 40.7276 10.4673 38.0029C11.1012 36.3701 12.7971 34.8236 12.8004 34.8202H12.7971Z"
          fill="white"
        />
        <path
          d="M13.5371 11.8579C14.9851 11.8579 16.1589 10.684 16.1589 9.23606C16.1589 7.78808 14.9851 6.61426 13.5371 6.61426C12.0891 6.61426 10.9153 7.78808 10.9153 9.23606C10.9153 10.684 12.0891 11.8579 13.5371 11.8579Z"
          fill="white"
        />
        <path
          d="M36.6819 11.9043C38.271 11.9043 39.5592 10.6161 39.5592 9.027C39.5592 7.43789 38.271 6.14966 36.6819 6.14966C35.0928 6.14966 33.8046 7.43789 33.8046 9.027C33.8046 10.6161 35.0928 11.9043 36.6819 11.9043Z"
          fill="white"
        />
        <path
          d="M36.0414 17.3604C36.0414 17.3604 35.3445 22.0298 34.8102 24.7811C34.8102 24.7811 28.2756 24.2633 28.0931 20.7588C28.0234 19.3881 29.6761 15.6778 30.5124 13.5173C30.6684 13.1091 29.0256 12.4653 28.7634 12.3557C27.6251 11.8745 26.4171 11.7484 25.2555 11.3668C24.5619 11.1378 23.7555 10.6931 23.928 9.83682C24.1039 8.95072 24.9502 8.82461 26.3474 8.99718C30.4792 9.51491 34.309 11.4431 37.0569 14.6092C38.4973 16.2685 39.7551 18.2365 40.3292 20.3738C40.6843 21.6946 40.6279 22.5774 39.8281 22.823C38.0326 23.3772 37.87 21.1039 37.4585 19.9623C37.12 19.0264 36.6189 18.1668 36.0447 17.3571L36.0414 17.3604Z"
          fill="white"
        />
        <path
          d="M22.8163 11.5624C23.0486 11.4927 23.2776 11.4794 23.48 11.4297C23.3971 11.3434 23.3207 11.2538 23.2544 11.1608C22.9358 10.7062 22.8263 10.1619 22.9424 9.59109C22.9723 9.43843 23.0187 9.28245 23.0851 9.12646C23.042 9.1331 23.0022 9.1331 22.959 9.13974C20.0551 9.52471 17.4864 10.6498 15.1766 12.4319C13.5006 13.7262 12.1267 15.4055 11.1211 17.2673C10.6664 18.1103 8.87431 21.4058 10.5635 21.9135C11.599 22.2255 12.0337 21.2498 12.3822 20.4798C12.9198 19.2884 13.5371 18.1335 14.2208 17.0184C14.5029 19.2187 14.9078 21.4224 15.3492 23.5961C15.3492 23.5961 21.3063 23.0817 21.449 19.8825C21.5054 18.6346 19.8958 15.0504 19.1159 13.0857C19.1159 13.0857 20.45 12.266 22.8163 11.5657V11.5624Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20708_74855">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
